import Hotjar from '@hotjar/browser';

const { VUE_APP_HOTJAR_SITE_ID } = process.env;
const hotjarVersion = 6;

VUE_APP_HOTJAR_SITE_ID && Hotjar.init(VUE_APP_HOTJAR_SITE_ID, hotjarVersion);
